import { API_ENDPOINT } from "@/utils/misc";
import axios from "axios";

export const getRoosterForecast = (from, until) => {
  return axios.get(`${API_ENDPOINT()}/rooster-forecast`, {
    params: { from, until },
  });
};
